document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.getElementById("loadMoreBtn");
  const productGrid = document.getElementById("productGrid");

  if (!loadMoreBtn || !productGrid) return;

  loadMoreBtn.addEventListener("click", async function () {
    const nextPage = parseInt(loadMoreBtn.dataset.page);
    const totalPages = parseInt(loadMoreBtn.dataset.pages);

    const url = `${window.location.pathname}?page=${nextPage}&view=ajax`;

    loadMoreBtn.disabled = true;
    loadMoreBtn.textContent = "Carregando...";

    try {
      const response = await fetch(url);
      const html = await response.text();

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      const newProducts = tempDiv.querySelectorAll(".product-grid > *");
      newProducts.forEach((product) => productGrid.appendChild(product));

      if (nextPage >= totalPages) {
        loadMoreBtn.remove();
      } else {
        loadMoreBtn.dataset.page = nextPage + 1;
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = "Carregar mais";
      }
    } catch (error) {
      loadMoreBtn.textContent = "Erro ao carregar";
    }
  });
});
